import { createReducer } from "@reduxjs/toolkit";
import type { UploadState } from "@redux/state/shared-types";
import { resetUploadImage, uploadImage } from "./upload-image";

const initialState: UploadState = { processing: "idle", url: null };

export const uploadImageReducer = createReducer<UploadState>(initialState, builder => {
  builder.addCase(uploadImage.fulfilled, (state, { payload }) => {
    return {
      ...state,
      url: payload,
      processing: "success",
    };
  });
  builder.addCase(uploadImage.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(uploadImage.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUploadImage, () => {
    return initialState;
  });
});
